import { isApiError } from '@api/common/is-api-error';
import { apiClientManager } from '@common/api';
import { isConstituentErrorData } from './common/constituent-error-codes';
function nullsToUndefined(obj) {
    // Backend can return nulls, but we need them as undefined to have the form
    // not dirty when we remove the provider (as nulls are not allowed,
    // it seems springdoc/swagger-core ignore @Schema(nullable=true) for Kotlin,
    // so we have a discrepancy of types between backend and frontend)
    const result = { ...obj };
    Object.keys(result).forEach(key => {
        if (result[key] === null) {
            result[key] = undefined;
        }
    });
    return result;
}
export async function getAiState() {
    var _a, _b, _c;
    const serviceClient = apiClientManager.getClient();
    try {
        const res = await serviceClient.get('/api/constituents/ai');
        return {
            status: 'enabled',
            data: {
                ...res.data,
                provider: nullsToUndefined(res.data.provider),
                defaultProviders: res.data.defaultProviders.sort()
            }
        };
    }
    catch (e) {
        if (isApiError(e)) {
            if (((_a = e.response) === null || _a === void 0 ? void 0 : _a.status) === 403 &&
                isConstituentErrorData(e.response.data) &&
                e.response.data.errorCode === 'AI_IS_NOT_ENABLED_IN_JBA') {
                return { status: 'not_enabled_in_jba', data: e.response.data };
            }
            if (((_b = e.response) === null || _b === void 0 ? void 0 : _b.status) === 404) {
                return { status: 'disabled' };
            }
            if (((_c = e.response) === null || _c === void 0 ? void 0 : _c.status) === 403) {
                return { status: 'disabled_by_license' };
            }
        }
        throw e;
    }
}
export async function enableAi(params) {
    const serviceClient = apiClientManager.getClient();
    const res = await serviceClient.post('/api/constituents/ai', params);
    return { status: 'enabled', data: res.data };
}
export async function changeAiSettings(params) {
    const serviceClient = apiClientManager.getClient();
    const res = await serviceClient.put('/api/constituents/ai', params);
    return { status: 'enabled', data: res.data };
}
export async function disableAi() {
    await apiClientManager.getClient().delete('/api/constituents/ai');
    return { status: 'disabled' };
}
export async function getProviderInfo(provider) {
    const res = await apiClientManager.getClient().get(`/api/constituents/ai/providers/${provider}`);
    return res.data;
}
export async function deleteProvider(provider, replaceBy) {
    const res = await apiClientManager
        .getClient()
        .delete(`/api/constituents/ai/providers/${provider}`, { params: { 'replace-by': replaceBy } });
    return res.data;
}
export async function getAiConfiguration() {
    const res = await apiClientManager
        .getClient()
        .get('/api/constituents/ai/config');
    return res.data;
}
export async function testProviderConnection(provider) {
    const serviceClient = apiClientManager.getClient();
    const res = await serviceClient.post(`/api/constituents/ai/providers/${provider.id}/test`, provider);
    return res.data;
}
